export default __webpack_public_path__ + "static/media/about.ddc2d979.png";